<div class="mt-50">
  <div class="row is-flex">
    <ng-container *ngIf="loading$ | async; else collection">
      <ecp-loader *ngIf="loading$ | async" [fluid]="true"></ecp-loader>
    </ng-container>
    <ng-template #collection>
      <div class="col is-flex is-fullwidth">
        <ecp-collection-search></ecp-collection-search>
      </div>

      <div class="col is-flex is-fullwidth">
        <ecp-print-my-collection></ecp-print-my-collection>
      </div>
      <div class="col is-flex is-fullwidth">
        <ecp-collection-list-table></ecp-collection-list-table>
      </div>
    </ng-template>
  </div>
</div>

